import { ReactElement } from 'react';
import { UnitStatus } from '~/providers/types/unit';
import { Badge } from './Badge';
import { useTranslation } from 'react-i18next';

interface StatusBadgeProps {
  production?: number | null;
  changed_by?: string;
}

export function StatusBadge({
  production,
  changed_by,
}: Readonly<StatusBadgeProps>): ReactElement | null {
  const { t } = useTranslation();
  const canShowBadge = [UnitStatus.MODERNIZATION, UnitStatus.FORCED_UNINSTALL, UnitStatus.DEACTIVATED];

  function renderLabel(): string {
    if (String(production) === UnitStatus.MODERNIZATION) {
      return t('unidadeEmModernizacao');
    }

    if (String(production) === UnitStatus.FORCED_UNINSTALL) {
      return t('unidadeEmDesinstalacaoForcada');
    }

    if (String(production) === UnitStatus.DEACTIVATED) {
      return t('unidadeDesmobilizada');
    }

    return '';
  }

  if (production && canShowBadge.includes(String(production) as UnitStatus)) {
    return (
      <div>
        <Badge label={renderLabel()} changed_by={changed_by} />
      </div>
    );
  }

  return null;
}
